package one.healthium.login.navigation.login

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.lifecycle.viewmodel.compose.LocalViewModelStoreOwner
import one.healthium.login.ui.login.LoginScreen

@Composable
fun SignInContent(component: SignInComponent) {
    CompositionLocalProvider(LocalViewModelStoreOwner provides component) {
        LoginScreen(component)
    }
}